import { Grid } from "@mui/material";

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import MDButton from "../../components/MDButton";
import { useCimbeo } from "../../context";

function HomeScreen() {
    const { user, setProjectName, setProjectId } = useCimbeo();
    const navigate = useNavigate();
    
    useEffect(() => {
        setProjectName("");
        setProjectId("");
    }, [setProjectName, setProjectId]);

    return (
        <DashboardLayout>
            <Grid container spacing={10}>
                <Grid item xs={12} lg={12}>
                    <MDBox sx={{width: "100%"}}>
                        <MDTypography variant="h2">Hello, {user.firstName} {user.lastName}</MDTypography>
                    </MDBox>
                </Grid>
                <Grid item xs={12} lg={12}>
                    <MDBox>
                        <Grid container spacing={3}>
                            <Grid item xs={6} lg={4}>
                                <MDButton
                                    fullWidth 
                                    variant="gradient"
                                    color="olive_green" 
                                    sx={{height: "150px", fontSize: 16}}
                                    onClick={() => navigate("/projects")}
                                >
                                    View Projects
                                </MDButton>
                            </Grid>
                            <Grid item xs={6} lg={4}>
                                <MDButton
                                    fullWidth 
                                    variant="gradient"
                                    color="olive_green"
                                    sx={{height: "150px", fontSize: 16}}
                                    onClick={() => navigate("/artifact-ingestion")}
                                >
                                    Ingest Artifacts
                                </MDButton>
                            </Grid>
                            <Grid item xs={6} lg={4}>
                                <MDButton 
                                    fullWidth 
                                    variant="gradient"
                                    color="olive_green"
                                    sx={{height: "150px", fontSize: 16}}
                                    onClick={() => navigate("/project-management")}
                                >
                                    Add / Manage Projects
                                </MDButton>
                            </Grid>
                            {/* Empty grid item is to push buttons over to center */}
                            <Grid item lg={2}/>
                            <Grid item xs={6} lg={4}>
                                <MDButton
                                    fullWidth 
                                    variant="gradient" 
                                    color="olive_green"
                                    sx={{height: "150px", fontSize: 16}}
                                >
                                    Manage Artifacts
                                </MDButton>
                            </Grid>
                            <Grid item xs={6} lg={4}>
                                <MDButton 
                                    fullWidth
                                    variant="gradient"
                                    color="olive_green"
                                    sx={{height: "150px", fontSize: 16}}
                                    onClick={() => navigate("/admin")}
                                >
                                    Admin
                                </MDButton>
                            </Grid>
                        </Grid>
                    </MDBox>
                </Grid>
            </Grid>
        </DashboardLayout>
    )
}

export default HomeScreen;